// extracted by mini-css-extract-plugin
export default {"email":"email_email__3vxkM"};